import { render, staticRenderFns } from "./NotaComercialAssignButton.vue?vue&type=template&id=0e297916&scoped=true"
import script from "./NotaComercialAssignButton.vue?vue&type=script&lang=js"
export * from "./NotaComercialAssignButton.vue?vue&type=script&lang=js"
import style0 from "./NotaComercialAssignButton.vue?vue&type=style&index=0&id=0e297916&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e297916",
  null
  
)

export default component.exports